import { configureStore } from '@reduxjs/toolkit';

import api from './api';

import chargingPointReducer from './reducers/chargingPointSlice';
import chargingPointsReducer from './reducers/chargingPointsSlice';
import authReducer from './reducers/authSlice';
import userTypeReducer from "./reducers/userTypeSlice.js";


const store = configureStore({
  reducer: {
    chargingPoint: chargingPointReducer,
    chargingPoints: chargingPointsReducer,
    auth: authReducer,
    userType: userTypeReducer,
    [api.reducerPath]: api.reducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware),
  devTools: process.env.NODE_ENV !== 'production'
});
export default store;
